import React from 'react'
import Modal from 'react-bootstrap/Modal'
import {Button} from "react-bootstrap";

import Select from "../common/CustomSelect";
import LazyLoadingList from "../common/LazyLoadingList";
import LoadingItem from "../common/LoadingItem";
import AsyncSelect from "../common/AsyncSelect";
import Separator from "../common/Separator";

import Backend from '../../../utils/Backend'
import Notify from '../../../utils/Notify'
import General from "../../../utils/General";
import Mode from "../../../utils/Mode";
import AuthManager from "../../../utils/AuthManager";

export default class OrderTerminalModal extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      ...this._getState(props),
      show: props.show,
      loading: false,
      error: null,
      association: window.General.DefaultAssociation || null,
      associationProcessor: null,
      selectedRegion: null,
      terminalModels: [],
    }

    this.lazyLoadingList = React.createRef();
  }

  componentWillReceiveProps(nextProps) {
    this.setState(this._getState(nextProps))
  }

  _getState(props) {
    return {
      ...props,
    }
  }

  _handleOrder() {
    let {
      terminalModels,
      selectedRegion,
      associationProcessor
    } = this.state

    const lineItems = terminalModels.filter((terminalModel) => terminalModel.quantity || terminalModel.quantity > 0)

    if(lineItems.length < 1){
      Notify.error('Please input the number of terminals needed')
      return
    }

    this.setState({loading: true})

    const terminalOrder = {
      line_items: lineItems.map((lineItem) => ({...lineItem, external_product_id: lineItem.external_id})),
      region: selectedRegion,
      association_processor: associationProcessor.id
    }

    Backend.createTerminalOrder(terminalOrder)
      .then(() => {
        Notify.success("Terminal Order Successfully Created")
        this.props.onSuccess()
      })
      .catch((error) => {
        Notify.error(error.message);
        this.setState({loading: false})
      })
  }

  _renderPlaceholderItems() {
    return (
      <>
        <div>
          <LoadingItem />
        </div>
      </>
    );
  }

  _renderNoContent() {
    return (
      <div className="no-content">
        <div className="no-content-section text-center mt-10">
          <h3>Oops, no terminal models found...</h3>
        </div>
      </div>
    );
  }

  _getSingleAssociationProcessor(associationProcessor) {
    if (!associationProcessor || typeof associationProcessor !== 'object') return ''
    return {
      value: associationProcessor.id,
      label: `${associationProcessor.processor.name}`,
      data: associationProcessor
    }
  }

  _getAssociationProcessorOptions(associationProcessors){
    return associationProcessors.map(associationProcessor => ({
      value: associationProcessor.id,
      label: `${associationProcessor.processor.name}`,
      data: associationProcessor
    }))
  }

  render() {
    let {
      show,
      loading,
      company,
      error,
      association,
      associationProcessor,
      selectedRegion,
      terminalModels,
    } = this.state

    let url = `${window.Api.TerminalModels}?processor_slug=${associationProcessor?.processor.slug}&region=${selectedRegion}`;

    let showTable = false
    if(AuthManager.isPlatformAdmin()){
      showTable = !!(association && associationProcessor && selectedRegion);
    }else{
      showTable = !!(associationProcessor && selectedRegion);
    }

    return (
      <Modal
        show={show}
        onHide={() => this.props.onHide()}
        centered
        className={`reassign-modal`}
        size="lg"
      >
        <Modal.Header>
          <Modal.Title>Order Terminal</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {
            AuthManager.isPlatformAdmin() &&
            <div className="form-group row">
              <label className="col-3 col-form-label">Partner</label>
              <div className="col-9">
                <AsyncSelect
                  endpoint={window.Api.Associations}
                  className={'custom-async-select__container'}
                  classNamePrefix={'custom-async-select'}
                  filter={`live=${!Mode.isDemoToggled()}`}
                  orderBy={"name"}
                  placeholder={"Select Partner"}
                  value={General.getSingleAsyncOption(association)}
                  getOptions={associations => General.getAsyncOptions(associations)}
                  onSelected={association => {
                    this.setState({
                      association,
                      associationProcessor: null
                    })
                  }}
                />
              </div>
            </div>
          }

          <div className="form-group row">
            <label className="col-3 col-form-label">Processor</label>
            <div className="col-9">
              <AsyncSelect
                endpoint={window.Api.AssociationProcessors}
                className={'custom-async-select__container'}
                classNamePrefix={'custom-async-select'}
                filter={`live=${!Mode.isDemoToggled()}&supports_terminals=true&${association ? `association_id=${association?.id}` : ''}`}
                orderBy={"processor__name"}
                placeholder={"Select Processor"}
                disabled={AuthManager.isPlatformAdmin() && !association}
                value={this._getSingleAssociationProcessor(associationProcessor)}
                getOptions={associations => this._getAssociationProcessorOptions(associations)}
                onSelected={associationProcessor => {
                  this.setState({
                    associationProcessor
                  })
                }}
              />
            </div>
          </div>
          <div className="form-group row">
            <label className="col-3 col-form-label">Region</label>
            <div className="col-9">
              <Select
                value={REGION.find(region => region.value === selectedRegion)}
                className="form-control h-auto border-0 form-control-solid c-selectbox"
                name="account_holder_type"
                placeholder="Please Select A Region"
                onChange={option => {
                  selectedRegion = option.value
                  this.setState({
                    selectedRegion
                  })
                }}
                options={REGION}
              />
            </div>
          </div>

          {
            showTable &&
            <>
              <Separator text="Select Terminals"/>
              <div className="ReactTable">
                <div className="rt-table" role="grid">
                  <div
                    className="rt-thead -header"
                    style={{
                      boxShadow: "rgba(0, 0, 0, 0.1) 0px 1px 1px 0px",
                      paddingTop: 10,
                      paddingBottom: 10,
                      textAlign: "left",
                      minWidth: 530,
                    }}
                  >
                    <div className="rt-tr" role="row">
                      <div
                        className="rt-th"
                        role="columnheader"
                        tabIndex={-1}
                        style={{
                          textAlign: "left",
                          paddingLeft: 10,
                        }}
                      >
                        <div className="rt-resizable-header-content">
                          Terminal Model
                        </div>
                        <div className="rt-resizer" />
                      </div>
                      <div
                        className="rt-th"
                        role="columnheader"
                        tabIndex={-1}
                        style={{
                          textAlign: "left",
                          paddingLeft: 10,
                        }}
                      >
                        <div className="rt-resizable-header-content">
                          Quantity
                        </div>
                        <div className="rt-resizer" />
                      </div>
                    </div>
                    <div className="separator separator-solid my-0" />
                  </div>

                  <div
                    className="rt-tbody"
                    style={{
                      minWidth: 530,
                    }}
                  >
                    <LazyLoadingList
                      ref={this.lazyLoadingList}
                      endpoint={url}
                      onItemUpdated={(terminalModels, isInitialLoading) => {
                        console.log(terminalModels);
                        this.setState({
                          terminalModels,
                        });
                      }}
                      renderItem={(terminalModel) => {
                        return (
                          <>
                            <div className="rt-tr-group" role="rowgroup">
                              <div
                                className="rt-tr -odd"
                                role="row"
                                style={{
                                  color: "black",
                                  paddingTop: 10,
                                  paddingBottom: 10,
                                }}
                              >
                                <div
                                  className="rt-td"
                                  role="gridcell"

                                  style={{
                                    padding: 13
                                  }}
                                >
                                  <span className="text-dark font-weight-bold">
                                    {terminalModel.name}
                                  </span>
                                </div>
                                <div
                                  className="rt-td"
                                  role="gridcell"

                                  style={{
                                    padding: 13
                                  }}
                                >
                                  <input
                                    name="priority"
                                    type="number"
                                    step="1"
                                    min="0"
                                    className="form-control"
                                    defaultValue={ terminalModels.find(terminalModel_ => terminalModel_.external_id === terminalModel.external_id).quantity || 0}
                                    onChange={e => {
                                      const value = Math.max(Number(e.target.value), 0);

                                      const updatedTerminalModels = terminalModels.map(model => {
                                        if (model.external_id === terminalModel.external_id) {
                                          return {
                                            ...model,
                                            quantity: value
                                          };
                                        }

                                        return model;
                                      });

                                      this.setState({
                                        terminalModels: updatedTerminalModels,
                                      })
                                    }}
                                  />
                                </div>
                              </div>
                              <div className="separator separator-solid my-0" />
                            </div>
                          </>
                        );
                      }}
                      renderInitialLoading={() => this._renderPlaceholderItems()}
                      renderLoadingMore={() => this._renderPlaceholderItems}
                      renderNoContent={() => this._renderNoContent()}
                    />
                  </div>
                </div>
              </div>
            </>
          }

        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => this.props.onHide()}
          >
            Close
          </Button>
          <Button
            variant="primary"
            disabled={loading || !associationProcessor}
            onClick={() => this._handleOrder()}
          >
            Order
          </Button>
        </Modal.Footer>
      </Modal>
    )
  }
}

const REGION = [
  {
    label: "EU",
    value: "eu"
  },
  {
    label: "North America",
    value: "na"
  },
]
